import React from "react";
import { Clock, Wallet, Shield } from "lucide-react";

const PILLARS = [
  {
    icon: Clock,
    title: "Gain de temps considérable",
    body:
      "Réduction de 70% du temps administratif. Automatisez vos rappels, générez vos quittances en un clic, et centralisez toutes vos données en un seul endroit.",
    accent: "70% de temps gagné",
  },
  {
    icon: Wallet,
    title: "Réduction des impayés",
    body:
      "Jusqu'à 90% de réduction des impayés grâce aux rappels SMS automatiques. Ne manquez plus jamais une révision triennale de loyer.",
    accent: "90% d'amélioration",
  },
  {
    icon: Shield,
    title: "Tranquillité d'esprit",
    body:
      "Toutes vos données sécurisées dans le cloud. États des lieux numériques avec signature électronique. Accès 24/7 depuis n'importe quel appareil.",
    accent: "Sérénité totale",
  },
];

const Philosophy = () => {
  return (
    <section
      id="avantages"
      data-testid="philosophy-section"
      className="relative bg-[#FAFAF8] py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-16">
        {/* Section label */}
        {/* <div className="flex items-center gap-3 mb-10">
          <span className="mikassa-diamond" />
          <span className="font-body text-[0.7rem] uppercase tracking-[0.32em] text-[#636E72]">
            Pourquoi Mikassa Agency
          </span>
        </div> */}

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-20 lg:mb-28">
          <h2
            className="lg:col-span-7 font-heading font-black text-[#0C2340] text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tighter"
            data-testid="philosophy-title"
          >
            La gestion locative,
            <br />
            <span className="text-[#E8611A]">enfin simplifiée</span>
            <br />
            pour les professionnels.
          </h2>
          <p className="lg:col-span-5 font-body text-[#2D3436] text-base md:text-lg leading-relaxed lg:pb-4">
            Mikassa Agency remplace vos feuilles Excel, vos classeurs papier et vos rappels
            manuels. Gérez tous vos biens, locataires et contrats depuis une seule interface
            moderne, conçue pour le marché ivoirien.
          </p>
        </div>

        {/* 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {PILLARS.map((p, idx) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`philosophy-pillar-${idx}`}
                className="group relative reveal border-t border-[#0C2340]/15 pt-8 hover:border-[#E8611A] transition-colors duration-500"
                style={{ transitionDelay: `${idx * 100}ms` }}
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-heading font-black text-[#0C2340]/12 text-6xl md:text-7xl tracking-tighter select-none leading-none">
                    0{idx + 1}
                  </span>
                  <Icon
                    size={28}
                    strokeWidth={1.4}
                    className="text-[#E8611A] group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                {/* <span className="font-body text-[0.65rem] uppercase tracking-[0.28em] text-[#E8611A] mb-3 block">
                  {p.accent}
                </span> */}
                <h3 className="font-heading font-bold text-[#0C2340] text-xl md:text-2xl leading-tight mb-4 tracking-tight">
                  {p.title}
                </h3>
                <p className="font-body text-[#2D3436] text-sm md:text-base leading-relaxed">
                  {p.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
